export default __webpack_public_path__ + "static/media/joint-bd-head.9e0053ae.jpg";